/*
    Add here your own custom javascript ‌‍‍‌‍‍‍⁠‌​​‌‍​​‌‌‍​‌‌‌‍​‌​‌‍​‌​‌‍​​​​‍​​‌​‍​​​‌‍​​​​‍​‌‌​‍​‌‌‌‍​​​​‍​‌‌​﻿‍‌‍‍​‍‍​‍
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

document.addEventListener('click', event => {
    const link = event.target.closest('[data-wowo-view]');
    if (!link) return;
    event.preventDefault();
    const destination = new URL(window.location.href);
    destination.searchParams.set('view', link.dataset.wowoView);
    window.location.assign(destination.href);
});
